<template>
  <section>
    <div class="d-flex justify-content-start align-items-center">
      <b-img
        v-if="item && item.product && item.product.image"
        class="avatar-tag-image mr-2"
        :class="{ '--dyot': isDYOT }"
        :src="getImage(item.product.image.original)"
        alt=""
        width="80px"
        fluid
      />
      <div class="d-block w-100">
        <DpSelect v-model="selectedPetId" :options="options" class="w-100" :rules="rules" />
        <small
          v-if="
            selectedPet &&
            item.customTagOrderInfo &&
            item.customTagOrderInfo.name &&
            selectedPet.name.toLowerCase() !== item.customTagOrderInfo.name.toLowerCase() &&
            itemProductType !== 'COLLAR'
          "
          class="text-warning d-inline-flex"
        >
          {{ $t('petSelect.personalizationNotMatch', [item.customTagOrderInfo ? item.customTagOrderInfo.name : '']) }}
        </small>
      </div>
    </div>
  </section>
</template>

<script>
import getImage from '@/mixins/getImage';
import DpSelect from './library/Select';

export default {
  name: 'PetSelect',
  components: { DpSelect },
  mixins: [getImage],
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      required: true,
    },
    pets: {
      type: Array,
      required: true,
    },
    petOwner: {
      type: Object,
      required: true,
    },
    rehydrateState: {
      type: Object,
      default: null,
      required: false,
    },
    rules: {
      type: String,
      default: 'required',
      required: false,
    },
  },
  data() {
    return {
      selectedPetId: null,
    };
  },
  computed: {
    itemProductType() {
      return this.item?.product?.type;
    },
    isDYOT() {
      return this.item?.product?.style?.code === 'DYOT';
    },
    options() {
      return [
        { value: null, text: `Who is this ${this.item?.product?.type === 'COLLAR' ? 'collar' : 'tag'} for?`, disabled: true },
        ...this.pets.map(({ id, name }) => ({
          value: id,
          text: `${name} ${
            this.item?.customTagOrderInfo?.name?.toLowerCase() === name.toLowerCase() &&
            this.selectedPet?.name?.toLowerCase() !== name.toLowerCase()
              ? '[Personalized]'
              : ''
          }`,
        })),
        { value: null, text: 'Add another pet', to: { name: 'AddPet', params: { autoAssignBackProductId: this.item?.id } } },
      ];
    },
    selectedPet() {
      return this.pets?.find(({ id }) => id === this.selectedPetId);
    },
  },
  watch: {
    selectedPetId: function () {
      this.emitAssignItemToPet();
    },
    personalize: {
      handler: function () {
        this.emitAssignItemToPet();
      },
      deep: true,
    },
  },
  created() {
    if (this.item?.customTagOrderInfo?.id) {
      this.selectedPetId = this.pets?.find((pet) => pet?.name?.toLowerCase() === this.item?.customTagOrderInfo?.name?.toLowerCase())?.id;
    }
    if (this.rehydrateState && this.item?.id) {
      const state = this.rehydrateState[this.item.id];
      if (state?.petId) {
        this.selectedPetId = state?.petId;
      } else {
        // Auto assign pet item
        let autoAssignProduct = this.$router?.currentRoute?.params?.autoAssignProduct;
        if (this?.item?.id == autoAssignProduct?.itemId && autoAssignProduct?.petId) {
          this.selectedPetId = autoAssignProduct.petId;
        }
      }
    }
  },
  methods: {
    emitAssignItemToPet() {
      this.$emit('assignItemToPet', {
        itemId: this.item.id,
        petId: this.selectedPetId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-tag-image {
  min-width: 150px;
  &.--dyot {
    padding: 0 19px;
  }
}
</style>
